module.exports = __webpack_public_path__ + "static/media/canhemon_small@3x.720ffa11.jpg";